<script setup lang="ts">
interface Props {
  placeholder?: string
  disabled?: boolean
  readonly?: boolean
  required?: boolean
  autofocus?: boolean
  name?: string
  id?: string
  rows?: number
  resize?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  color?: 'primary' | 'gray'
  variant?: 'outline' | 'none'
  autoresize?: boolean
  maxrows?: number
}

const props = withDefaults(defineProps<Props>(), {
  rows: 3,
  resize: true,
  size: 'md',
  color: 'primary',
  variant: 'outline'
})

const modelValue = defineModel<string>()

const sizeClasses = {
  xs: 'text-xs px-2 py-1',
  sm: 'text-sm px-2.5 py-1.5',
  md: 'text-sm px-3 py-2',
  lg: 'text-base px-4 py-2.5',
  xl: 'text-base px-4 py-3'
}

const textareaClasses = computed(() => [
  'block w-full rounded-md shadow-sm transition-colors',
  'placeholder:text-gray-400',
  'focus:outline-none focus:ring-2 focus:ring-offset-0',
  props.variant === 'outline'
    ? 'border border-gray-300 bg-white focus:border-primary-500 focus:ring-primary-500'
    : 'border-0 bg-transparent',
  'disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed',
  'text-gray-900',
  sizeClasses[props.size],
  props.resize ? 'resize-y' : 'resize-none'
])
</script>

<template>
  <textarea
    :id="id"
    v-model="modelValue"
    :name="name"
    :rows="rows"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :required="required"
    :autofocus="autofocus"
    :class="textareaClasses"
  />
</template>
